import { getInitialState } from './state';

const mutations = {
  SET_CLEAR_PAYMENTS(state) {
    Object.assign(state, getInitialState());
  },

  // GET_PIX_INFO(state, questionnaire) {
  //   state.status = questionnaire;
  // },

  SET_PIX_DATA(state, paymentInfos) {
    state.specificFields = paymentInfos;
  }
};

export default mutations;
